var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCertify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6471 23.0588V31L22.1765 28.3529L25.7059 31V23.0588M13.3529 25.7059H4.52941C3.59335 25.7059 2.69563 25.334 2.03374 24.6721C1.37185 24.0102 1 23.1125 1 22.1765V4.52941C1 2.58824 2.58824 1 4.52941 1H29.2353C30.1714 1 31.0691 1.37185 31.731 2.03374C32.3929 2.69563 32.7647 3.59335 32.7647 4.52941V22.1765C32.7641 22.7954 32.6007 23.4033 32.291 23.9391C31.9812 24.475 31.536 24.9199 31 25.2294M6.29412 8.05882H27.4706M6.29412 13.3529H11.5882M6.29412 18.6471H9.82353M16.8824 18.6471C16.8824 20.0511 17.4401 21.3977 18.433 22.3906C19.4258 23.3834 20.7724 23.9412 22.1765 23.9412C23.5806 23.9412 24.9271 23.3834 25.92 22.3906C26.9128 21.3977 27.4706 20.0511 27.4706 18.6471C27.4706 17.243 26.9128 15.8964 25.92 14.9036C24.9271 13.9107 23.5806 13.3529 22.1765 13.3529C20.7724 13.3529 19.4258 13.9107 18.433 14.9036C17.4401 15.8964 16.8824 17.243 16.8824 18.6471Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCertify);
export default __webpack_public_path__ + "static/media/new-certify.f32d5e505ab2cbbbb449ec672a637479.svg";
export { ForwardRef as ReactComponent };